<template>
  <section :style="style">
    <slot />
  </section>
</template>

<script>
const STICKY_BASE_OFFSET = 170;

export default {
  name: 'FiltersSidebarSection',
  props: {
    noPadding: {
      type: Boolean,
      default: false
    },
    stickyOffset: {
      type: Number,
      default: 0
    }
  },
  computed: {
    style() {
      let style = {
        'background': '#fff',
        'border-radius': '6px',
        // position: 'sticky',
        // top: `${STICKY_BASE_OFFSET + this.stickyOffset}px`
      };

      return style;
    }
  }
}
</script>
